export enum SyncTaskStatus {
  None,
  Started,
  Complete,
  Failed,
  Skipped,
}
